/**
 * @desc - 買い物かごに移動
 */

$(function() {
  var element = $('#moveCart');
  $(element).show();
  $('.product-Inview').on('inview', function(event, isInView) {
    var visible = element.is(':visible');
    if (isInView) {
      element.fadeOut('fast');
    } else{
      element.fadeIn('fast');
    }
  });
});